import { render, staticRenderFns } from "./MenuPagePopupForm.vue?vue&type=template&id=1d0a8b88&scoped=true"
import script from "./MenuPagePopupForm.vue?vue&type=script&lang=js"
export * from "./MenuPagePopupForm.vue?vue&type=script&lang=js"
import style0 from "./MenuPagePopupForm.vue?vue&type=style&index=0&id=1d0a8b88&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a8b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0a8b88')) {
      api.createRecord('1d0a8b88', component.options)
    } else {
      api.reload('1d0a8b88', component.options)
    }
    module.hot.accept("./MenuPagePopupForm.vue?vue&type=template&id=1d0a8b88&scoped=true", function () {
      api.rerender('1d0a8b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/popupWindows/components/MenuPagePopupForm.vue"
export default component.exports